import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { PlansAdmin } from '@/features/staff-workspace/PlansAdmin';

export const Route = createFileRoute('/admin/plans')({
  component: AdminPlansPage,
});

function AdminPlansPage() {
  const allowed = useCan('billing.admin');
  if (!allowed) {
    return (
      <StaffOnly
        title="You cannot edit plans"
        description="Only an admin can change prices, lengths and add-ons."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Plans and add-ons"
        description="Change prices, lengths and the free trial here. New prices apply to the next purchase. Every change is written to History."
      />
      <PlansAdmin />
    </div>
  );
}
